// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.creator-confirm-dialog {
  padding: 1.5rem;
  max-width: 440px;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 12px;
  text-align: left;
}

.dialog-title {
  margin: 0 0 0.75rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  text-align: left;
}

.dialog-message {
  margin: 0 0 1rem;
  color: #374151;
  line-height: 1.5;
  text-align: left;
}

.dialog-points {
  margin: 0 0 1rem;
  padding-left: 1.25rem;
  color: #374151;
  text-align: left;
}
.dialog-points li {
  margin-bottom: 0.35rem;
  line-height: 1.4;
  text-align: left;
}

.dialog-note {
  margin: 0 0 1.25rem;
  font-size: 0.875rem;
  color: #6b7280;
  text-align: left;
}

.assign-progress {
  margin: 0 0 1.25rem;
}

.assign-progress-label {
  margin: 0.65rem 0 0;
  font-size: 0.875rem;
  color: #5ea1d8;
  font-weight: 600;
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.btn-cancel,
.btn-confirm {
  border-radius: 8px;
  padding: 0.625rem 1.25rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  min-width: 88px;
}
.btn-cancel:disabled,
.btn-confirm:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-cancel {
  background: #f3f4f6;
  color: #374151;
}
.btn-cancel:hover:not(:disabled) {
  background: #e5e7eb;
}

.btn-confirm {
  background: #5ea1d8;
  color: #fff;
}
.btn-confirm:hover:not(:disabled) {
  background: #4a8bc4;
}

@media (max-width: 640px) {
  .creator-confirm-dialog {
    padding: 1.1rem 1rem calc(1.1rem + env(safe-area-inset-bottom, 0px));
    max-width: 100%;
    border-radius: 16px;
  }
  .dialog-title {
    font-size: 1.1rem;
  }
  .dialog-actions {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 0.55rem;
  }
  .btn-cancel,
  .btn-confirm {
    width: 100%;
    min-height: 44px;
  }
}
/* Dark mode — creator plan confirm modal */
:host-context(body.theme-dark) .creator-confirm-dialog {
  background: #111827 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .dialog-title {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .dialog-message,
:host-context(body.theme-dark) .dialog-points,
:host-context(body.theme-dark) .dialog-points li {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .dialog-message strong,
:host-context(body.theme-dark) .dialog-points strong {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .dialog-note {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .assign-progress-label {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .btn-cancel {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .btn-cancel:hover:not(:disabled) {
  background: #374151 !important;
}
:host-context(body.theme-dark) .btn-confirm {
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/pricingplan/creator-plan-confirm-dialog.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAEF;AAAE;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;;EACE,aAAA;EACA,mBAAA;AAEJ;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,mBAAA;EACA,WAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;;AAIA;EACE;IACE,oEAAA;IACA,eAAA;IACA,mBAAA;EADF;EAIA;IACE,iBAAA;EAFF;EAKA;IACE,8BAAA;IACA,oBAAA;IACA,YAAA;EAHF;EAMA;;IAEE,WAAA;IACA,gBAAA;EAJF;AACF;AAOA,2CAAA;AAEE;EACE,8BAAA;EACA,yBAAA;AANJ;AASE;EACE,yBAAA;AAPJ;AAUE;;;EAGE,yBAAA;AARJ;AAWE;;EAEE,yBAAA;AATJ;AAYE;EACE,yBAAA;AAVJ;AAaE;EACE,yBAAA;AAXJ;AAcE;EACE,8BAAA;EACA,yBAAA;AAZJ;AAcI;EACE,8BAAA;AAZN;AAgBE;EACE,yBAAA;AAdJ","sourcesContent":[".creator-confirm-dialog {\n  padding: 1.5rem;\n  max-width: 440px;\n  width: 100%;\n  box-sizing: border-box;\n  background: #fff;\n  border-radius: 12px;\n  text-align: left;\n}\n\n.dialog-title {\n  margin: 0 0 0.75rem;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #111827;\n  text-align: left;\n}\n\n.dialog-message {\n  margin: 0 0 1rem;\n  color: #374151;\n  line-height: 1.5;\n  text-align: left;\n}\n\n.dialog-points {\n  margin: 0 0 1rem;\n  padding-left: 1.25rem;\n  color: #374151;\n  text-align: left;\n\n  li {\n    margin-bottom: 0.35rem;\n    line-height: 1.4;\n    text-align: left;\n  }\n}\n\n.dialog-note {\n  margin: 0 0 1.25rem;\n  font-size: 0.875rem;\n  color: #6b7280;\n  text-align: left;\n}\n\n.assign-progress {\n  margin: 0 0 1.25rem;\n}\n\n.assign-progress-label {\n  margin: 0.65rem 0 0;\n  font-size: 0.875rem;\n  color: #5ea1d8;\n  font-weight: 600;\n}\n\n.dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n.btn-cancel,\n.btn-confirm {\n  border-radius: 8px;\n  padding: 0.625rem 1.25rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  min-width: 88px;\n\n  &:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n  }\n}\n\n.btn-cancel {\n  background: #f3f4f6;\n  color: #374151;\n\n  &:hover:not(:disabled) {\n    background: #e5e7eb;\n  }\n}\n\n.btn-confirm {\n  background: #5ea1d8;\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    background: #4a8bc4;\n  }\n}\n\n@media (max-width: 640px) {\n  .creator-confirm-dialog {\n    padding: 1.1rem 1rem calc(1.1rem + env(safe-area-inset-bottom, 0px));\n    max-width: 100%;\n    border-radius: 16px;\n  }\n\n  .dialog-title {\n    font-size: 1.1rem;\n  }\n\n  .dialog-actions {\n    flex-direction: column-reverse;\n    align-items: stretch;\n    gap: 0.55rem;\n  }\n\n  .btn-cancel,\n  .btn-confirm {\n    width: 100%;\n    min-height: 44px;\n  }\n}\n\n/* Dark mode — creator plan confirm modal */\n:host-context(body.theme-dark) {\n  .creator-confirm-dialog {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .dialog-title {\n    color: #f8fafc !important;\n  }\n\n  .dialog-message,\n  .dialog-points,\n  .dialog-points li {\n    color: #cbd5e1 !important;\n  }\n\n  .dialog-message strong,\n  .dialog-points strong {\n    color: #f8fafc !important;\n  }\n\n  .dialog-note {\n    color: #94a3b8 !important;\n  }\n\n  .assign-progress-label {\n    color: #93c5fd !important;\n  }\n\n  .btn-cancel {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n\n    &:hover:not(:disabled) {\n      background: #374151 !important;\n    }\n  }\n\n  .btn-confirm {\n    color: #ffffff !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
